import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../../store/config';
import { ScaleType } from './scaleType.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/scaleType');

export const getScaleTypeList = actionCreator.async<{}, ScaleType[]>('GET_SCALE_TYPE_LIST');
